import { render, staticRenderFns } from "./DraggableEffects.vue?vue&type=template&id=12b940a4&"
import script from "./DraggableEffects.vue?vue&type=script&lang=js&"
export * from "./DraggableEffects.vue?vue&type=script&lang=js&"
import style0 from "./DraggableEffects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports